import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-select-point",
  "use": "icon-select-point-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-select-point\"><path d=\"M14 7A7 7 0 1 1 0 7a7 7 0 0 1 14 0zM1.4 7a5.6 5.6 0 1 0 11.2 0A5.6 5.6 0 0 0 1.4 7zM10 7a3 3 0 1 1-6 0 3 3 0 0 1 6 0zm9.354 12.714h3.978c.582 0 .899-.468.469-.73l-10.666-6.856c-.388-.27-1.135-.084-1.135.3V22.5c0 .366.702.58 1.135.302l3.25-2.09 1.99 3.027c.146.215.531.322.875.228l1.843-.502c.334-.094.5-.342.355-.563l-2.094-3.187z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol